<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="reprintStockReport('printReport')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllOutstandingInvoice()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.customerIds"
                :items="selectedCustomerList"
                label="Customer"
                @click="showCustomers()"
                item-text="code"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="invoiceNo"
                label="Invoice No"
                v-model="queryParams.invoiceNo"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-flex
              sm3
              v-if="
                user.roleName == 'ADMIN' ||
                user.roleName == 'FINANCE_MANAGER' ||
                user.role.roleName == 'BRANCH_ADMIN'
              "
            >
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.wholeSaleStatus"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                :items="cityList"
                label="City"
                v-model="queryParams.cityIds"
                item-text="name"
                item-value="id"
                menu-props="auto"
                multiple
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="description"
                label="Description"
                type="text"
                v-model="queryParams.description"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="outstandingInvoiceReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                {{ props.item.dateInMilliSecond | format-ms-date }}
              </td>
              <td>{{ props.item.invoiceNo }}</td>
              <td>{{ props.item.customerCode }}</td>
              <td>{{ props.item.customerName }}</td>
              <td>{{ props.item.crd }}</td>
              <td style="text-align: right">
                {{ props.item.advAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.receipt | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.damage | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.netAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.remainingBalance | decFormat(6) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <summary report> -->
    <div
      id="printReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Outstanding Invoice Report Customer
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">Date</th>
              <th style="border: 1px solid black; text-align: center">
                Invoice No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Customer Code
              </th>
              <th style="border: 1px solid black; text-align: center">
                Customer Name
              </th>
              <th style="border: 1px solid black; text-align: center">C/R</th>
              <th style="border: 1px solid black; text-align: center">
                Adv Amount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Pay Amount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Damage
              </th>
              <th style="border: 1px solid black; text-align: center">
                Net Amount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Remaining Balance
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(
              outstandingInvoicePage, index
            ) in allOutstandingInvoiceReportPageList"
            :key="index"
          >
            <tr
              v-for="(
                item, i
              ) in outstandingInvoicePage.outstandingInvoiceReportList"
              :key="i"
            >
              <td style="border: 1px solid black; text-align: left">
                {{ item.dateInMilliSecond | format-ms-date }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.invoiceNo }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.customerCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.customerName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.crd }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.advAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.receipt | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.damage | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.netAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.remainingBalance | decFormat(6) }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
                colspan="9"
              >
                Sub Total
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{
                  outstandingInvoicePage.subTotalRemainingAmount | decFormat(6)
                }}
              </td>
            </tr>
          </tbody>
          <tr>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
              colspan="9"
            >
              Grand Total
            </td>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
            >
              {{ grandTotalRemainingAmount | decFormat(6) }}
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- Customer dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="code"
                label="Customer Code"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.email"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchCustomer">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              v-model="selectedCustomerList"
              :headers="customerHeader"
              :items="activeCustomerList"
              select-all
              class="elevation-1"
              :loading="showListLoading"
              :total-items="customertotalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="customerpagination"
              :must-sort="true"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th>
                    <v-checkbox
                      primary
                      hide-details
                      @click.native="toggleAll"
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                    ></v-checkbox>
                  </th>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    :input-value="props.selected"
                    :value="props.item"
                    :indeterminate="props.indeterminate"
                    v-model="selectedCustomerList"
                    multiple
                  ></v-checkbox>
                </td>
                <td>
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.phoneNo }}</td>
                <td>{{ props.item.creditLevel.name }}</td>
              </template>
            </v-data-table>
            <div class="text-xs-right">
              <v-btn color="primary" @click="setCustomer">Ok</v-btn>
            </div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End dialog -->
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { customerService } from "../../services/customer-service";
import { outstandingInvoiceReportService } from "../../services/outstanding-invoice-report-service";
import { shopService } from "../../services/shop-service";
import { cityService } from "../../services/city-service";

export default {
  name: "OutstandingInvoiceReport",
  components: {},

  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showCustomerListDialog: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Report",
        disabled: true,
      },
      {
        text: "Sale Reports",
        disabled: true,
      },
      {
        text: "Outstanding Invoice Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Date", align: "left", value: "dateInMilliSecond" },
      { text: "Invoice No", align: "left", value: "invoiceNo" },
      { text: "Customer Code", align: "left", value: "customerCode" },
      { text: "Customer Name", align: "left", value: "customerName" },
      { text: "C/R", align: "left", value: "crd" },
      { text: "Adv Amount", value: "advAmount" },
      { text: "Pay Amount", value: "receipt" },
      { text: "Damage", value: "damage" },
      { text: "Net Amount", value: "netAmount" },
      { text: "Remaining Balance", value: "remainingBalance" },
    ],
    customerHeader: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
    ],
    statusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "QUOTATION", value: "QUOTATION" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "null",
      totalItems: 0,
    },
    totalRows: 0,
    cityList: [],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      customerIds: [],
      invoiceNo: "",
      shopId: "",
      wholeSaleStatus: "FINISHED",
      cityIds: [],
      updateUserId: "",
      description: "",
    },
    outstandingInvoiceReportList: [],
    shopList: [],
    allOutstandingInvoiceReportPageList: [],
    decimalFormat: "",

    clonequeryParams: new Object(),
    activeCustomerList: [],
    customerQueryParams: {
      name: "",
      code: "",
      email: "",
    },
    customerpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    customertotalRows: 0,
    selectedCustomerList: [],
    customerName: "",
    grandTotalRemainingAmount: 0,
  }),
  watch: {
    pagination: {
      handler() {
        this.getOutstandingInvoiceReport();
      },
      deep: true,
    },
    customerpagination: {
      handler() {
        this.getActiveCustomer();
      },
      deep: true,
    },
  },

  created() {
    if (this.user.role.roleName == "SALE_MANAGER") {
      this.queryParams.updateUserId = this.user.id;
    }
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = this.$route.query.updateUserId;
    }
    if (this.$route.query.description) {
      this.queryParams.description = this.$route.query.description;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
    this.onSearch();
    this.getShopList();
    this.getAllCity();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "outstanding-invoice-report",
        query: this.queryParams,
      });
      this.getOutstandingInvoiceReport();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
    },

    getOutstandingInvoiceReport() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      outstandingInvoiceReportService
        .getOutstandingInvoiceReport(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.outstandingInvoiceReportList =
              res.data.outstandingInvoiceReportList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getAllCity() {
      cityService
        .getAllCity()
        .then((res) => {
          this.cityList = res.data.cityList;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    showCustomers() {
      // Clean query params
      this.customerQueryParams.code = "";
      this.customerQueryParams.name = "";
      this.customerQueryParams.email = "";
      this.selectedCustomerList = [];
      this.queryParams.customerIds = [];

      this.getActiveCustomer().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },

    setCustomer() {
      if (this.selectedCustomerList.length) {
        this.queryParams.customerIds = [];
        this.selectedCustomerList.forEach((element) => {
          if (!this.queryParams.customerIds.includes(element.id))
            this.queryParams.customerIds.push(element.id);
        });
      }
      this.showCustomerListDialog = !this.showCustomerListDialog;
    },

    onSearchCustomer() {
      this.customerQueryParams.page = this.customerpagination.page;
      this.customerQueryParams.size = this.customerpagination.rowsPerPage;
      this.getActiveCustomer();
    },
    getActiveCustomer() {
      this.showListLoading = true;
      let order = this.customerpagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerpagination.page,
          this.customerpagination.rowsPerPage,
          this.customerpagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.activeCustomerList = res.data.customerList;
            this.customertotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    toggleAll() {
      if (this.selectedCustomerList.length) {
        this.selectedCustomerList = [];
      } else {
        this.selectedCustomerList = this.activeCustomerList.slice();
      }
    },

    reprintStockReport(divName) {
      this.buttonLoading = true;
      outstandingInvoiceReportService
        .getAllOutstandingInvoiceReport(this.clonequeryParams)
        .then((res) => {
          this.allOutstandingInvoiceReportPageList =
            res.data.outstandingInvoiceReportPageList;
          this.grandTotalRemainingAmount = res.data.grandTotalRemainingAmount;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
    exportAllOutstandingInvoice() {
      this.buttonLoading = true;
      outstandingInvoiceReportService
        .getOutstandingInvoiceReportExcelExport(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
  },
};
</script>